import { render, staticRenderFns } from "./HealthrecordForm.vue?vue&type=template&id=eb451182&"
import script from "./HealthrecordForm.vue?vue&type=script&lang=js&"
export * from "./HealthrecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports